/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardContent,
  CardMedia,
  Fab,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import {
  MOBLIE_VIEW_WIDTH,
  TAB_VIEW_WIDTH,
} from "../../shared/constants/constants";
import { PlayButton } from "../../shared/assets/icons/PlayButton.jsx";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { yellow } from "@mui/material/colors";
import { useEffect, useState } from "react";
import {
  getCarModelCharacteristics,
  getCarModelDetails,
  getCarModelTable,
} from "./apiCalls";
import { useParams } from "react-router-dom";
import { useRef } from "react";
import QuickLinksComp from "../../shared/components/reusableComp/QuickLinksComp";
import { v4 } from "uuid";
import Markdown from "markdown-to-jsx";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TableComponent from "../../shared/components/reusableComp/TableComponent";

const imgText = (matches) => css`
  color: white;
  display: flex;
  ${matches && "position: absolute;"}
  margin-top: ${matches ? "8%" : "5%"};
  margin-left: ${matches ? "10%" : "5%"};
  ${!matches && "padding-bottom: 20px; padding-right: 10px;"}
  flex-direction: column;
  z-index: 1;
`;

const hybridImgText = (matches) => css`
  width: ${matches ? "62%" : "90%"};
  color: white;
  ${matches && "position: absolute;"}
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  z-index: 1;
  transform: translate(${matches ? "30%, -125%" : "5%, 10%"});
  ${!matches && "flex-wrap: wrap; padding-bottom: 30px;"}
`;

const mediaVideo = (matches) => css`
  width: 100%;
  object-fit: unset;
  ${matches && "height: 45vw; min-height: 80vh; max-height: 86vh;"}
`;

const media = (matches) => css`
  ${matches && "height: 45vw; min-height: 80vh; max-height: 86vh;"}
`;

const body = () => css`
  font-size: 18px;
  line-height: 35px;
  max-width: 450px;
`;
const bannerHeaderstyle = (theme) => css`
  font-family: ${theme.typography.MBCORPOA};
`;

const quickContainerCss = (matches) => css`
  display: flex;
  justify-content: space-around;
  padding-top: 20px;
  margin-bottom: 40px;
  display: flex;
  justify-content: ${matches ? "center" : "space-evenly"};
  align-items: center;
`;

const buttonText = css`
  font-size: 14px;
  display: block;
  text-align: center;
  width: 100px;
  text-decoration: none;
  color: white;
  border: 2px solid white;
  border-radius: 25px;
  padding: 3px;
  margin-top: 10px;
`;

const boxcontent = css`
  display: flex;
  flex-direction: column-reverse;
  max-height: 86vh;
`;
const descriptionWrapper = css`
  font-size: 14px;
  line-height: 35px;
`;
const fontFamilyWrapper = (theme) => css`
  font-family: ${theme.typography.MBCORPOA};
`;
const boxcontentHybrid = css`
  display: flex;
  flex-direction: column;
`;

const playTag = (matches, index) => css`
  &:hover {
    cursor: pointer;
  }
  transform: translate(
    0%,
    ${matches ? (index === 0 ? "-400%" : "-340%") : "165%"}
  );
  ${!matches && "height: 0; position: relative; top: 8vh;"}
  display: block;
  margin: auto;
  width: fit-content;
`;

const cardWrapper = (direction, isImageRequiredOnRight) => css`
  background: #121212;
  .MuiBox-root {
    display: flex;
    align-items: center;
    img {
      width: ${direction === "row" ? "50%" : "100%"};
      order: ${direction === "row" && isImageRequiredOnRight === true ? 2 : -1};
    }
    .MuiCardContent-root {
      padding: 0;
      margin: 20px 0;
      width: ${direction === "row" ? "50%" : "100%"};
      .MuiTypography-root {
        margin: ${direction === "row" ? "30px 80px" : "10px 20px"};
        color: white;
      }
    }
  }
`;

const accordianSummaryStyle = css`
  background-color: #1f1c1c;
  color: white;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
`;

export default function CarModelDetail({ Slug }) {
  const [carModelDetailData, setCarModelDetailData] = useState([]);
  const [quickLinksData, setQuickLinksData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [characteristics, setCharacteristics] = useState([]);
  const [accordionData, setAccordionData] = useState([]);
  const [playVideo, setPlayVideo] = useState(false);
  const [displayFlag, setDisplayFlag] = useState(false);
  const matches = useMediaQuery(MOBLIE_VIEW_WIDTH);
  const matchesTab = useMediaQuery(TAB_VIEW_WIDTH);
  const myRef = useRef();
  const { slug } = useParams();

  useEffect(() => {
    slug &&
      getCarModelDetails(slug || Slug).then((data) => {
        const attr = data?.data?.data?.attributes;
        setDisplayFlag(attr?.displayTable);
        document.title = attr?.title;
        const temp = [];
        attr?.body?.map((item) => {
          if (item.__component === "components.list") {
            setQuickLinksData([...item.ctaList]);
          } else {
            if (item?.textTiles.length === 1 || item?.textTiles.length === 0) {
              if (item.bannerVideoSource) {
                temp.push({
                  type: "video",
                  heading: item?.textTiles[0]?.heading,
                  description: item?.textTiles[0]?.description,
                  media: item.bannerImage,
                  bannerVideoSource: item.bannerVideoSource,
                  link: item.link,
                  showVideoPlayIcon: item.showVideoPlayIcon,
                });
              } else {
                temp.push({
                  type: "image",
                  heading: item?.textTiles[0]?.heading,
                  description: item?.textTiles[0]?.description,
                  media: item.bannerImage,
                  bannerVideoSource: item.bannerVideoSource,
                  link: item.link,
                  showVideoPlayIcon: item.showVideoPlayIcon,
                });
              }
            } else {
              temp.push({
                type: "hybrid",
                features: item?.textTiles,
                media: item.bannerImage,
              });
            }
          }
        });
        setCarModelDetailData([...temp]);
        if (attr?.truck_model_accordians?.data?.length > 0) {
          setAccordionData([...attr.truck_model_accordians.data]);
        }
      });
  }, [slug]);

  useEffect(() => {
    getCarModelTable().then((data) => {
      if (data?.data?.data?.length > 0) setTableData([...data.data.data]);
    });
    getCarModelCharacteristics().then((data) => {
      if (data?.data?.data?.length > 0) setCharacteristics([...data.data.data]);
    });
  }, []);

  const renderCard = (
    imgUrl,
    imgName,
    title,
    description,
    direction,
    isImageRequiredOnRight
  ) => {
    return (
      <Card
        css={() => cardWrapper(direction, isImageRequiredOnRight)}
        key={v4()}
      >
        <Box sx={{ display: "flex", flexDirection: direction }}>
          {imgUrl && (
            <CardMedia
              component="img"
              image={`${process.env.REACT_APP_BASEURL}${imgUrl}`}
              alt={imgName}
            />
          )}
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {title}
            </Typography>
            <Typography
              css={descriptionWrapper}
              variant="body2"
              color="text.secondary"
            >
              <Markdown>{description || ""}</Markdown>
            </Typography>
          </CardContent>
        </Box>
      </Card>
    );
  };

  const handleClick = (index) => {
    setPlayVideo(true);
    document.getElementById("carModelDetail" + index).play();
  };

  const handleScroll = () => {
    myRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Grid container style={{ backgroundColor: "#121212" }}>
      {carModelDetailData.map((item, index) => (
        <Grid
          key={index}
          ref={index === 1 ? myRef : null}
          style={{
            width: "100%",
            scrollMarginTop: `${
              (matches && "85px") || (matchesTab && "69px") || "56px"
            }`,
            maxHeight: "86vh",
          }}
          item
        >
          {item.type === "image" ? (
            <Box css={!matches && boxcontent}>
              {(item?.heading || item?.description) && (
                <Box css={() => imgText(matches)}>
                  <Typography
                    p={1}
                    variant={matches ? "h2" : "h4"}
                    css={(theme) => bannerHeaderstyle(theme)}
                  >
                    {item?.heading}
                  </Typography>
                  <Typography
                    p={1}
                    pt={matches ? 4 : 2}
                    css={() => body(matches)}
                    variant="body1"
                  >
                    <Markdown>{item?.description || ""}</Markdown>
                  </Typography>
                </Box>
              )}
              {(item.media?.data?.attributes?.url ||
                item.media?.data?.attributes?.formats.small.url) && (
                <CardMedia
                  component="img"
                  css={() => media(matches)}
                  onClick={() =>
                    !item?.showVideoPlayIcon &&
                    item?.link &&
                    (window.location = item?.link)
                  }
                  image={
                    process.env.REACT_APP_BASEURL +
                    (matches
                      ? item.media?.data?.attributes?.url
                      : item.media?.data?.attributes?.formats.small.url)
                  }
                ></CardMedia>
              )}
              {matches && index === 0 && (
                <Fab
                  onClick={handleScroll}
                  style={{
                    bottom: "70px",
                    left: "48%",
                    background: "transparent",
                    boxShadow: "none",
                    zIndex: 1,
                  }}
                >
                  <KeyboardArrowDownIcon
                    style={{ fontSize: "40px" }}
                    sx={{ color: yellow[50] }}
                  ></KeyboardArrowDownIcon>
                </Fab>
              )}
              {item?.showVideoPlayIcon && (
                <a
                  href={
                    item.bannerVideoSource ? item.bannerVideoSource : item.link
                  }
                  css={() => playTag(matches, index)}
                >
                  <PlayButton
                    style={{
                      fontSize: "80px",
                    }}
                    sx={{ color: yellow[50] }}
                  ></PlayButton>
                </a>
              )}
            </Box>
          ) : item.type === "video" ? (
            <Box css={!matches && boxcontent}>
              {(item?.heading || item?.description) && (
                <Box css={() => imgText(matches)}>
                  <Typography
                    p={1}
                    variant={matches ? "h2" : "h4"}
                    css={(theme) => bannerHeaderstyle(theme)}
                  >
                    {item?.heading}
                  </Typography>
                  <Typography
                    p={1}
                    pt={matches ? 4 : 2}
                    css={() => body(matches)}
                    variant="body1"
                  >
                    <Markdown>{item?.description || ""}</Markdown>
                  </Typography>
                </Box>
              )}
              <CardMedia
                id={"carModelDetail" + index.toString()}
                component="video"
                controls={playVideo}
                css={() => mediaVideo(matches)}
                image={item.bannerVideoSource}
              />
              {matches && index === 0 && (
                <Fab
                  onClick={handleScroll}
                  style={{
                    bottom: "70px",
                    left: "48%",
                    background: "transparent",
                    boxShadow: "none",
                    zIndex: 1,
                  }}
                >
                  <KeyboardArrowDownIcon
                    style={{ fontSize: "40px" }}
                    sx={{ color: yellow[50] }}
                  ></KeyboardArrowDownIcon>
                </Fab>
              )}
              {!playVideo &&
                item.showVideoPlayIcon &&
                (item.bannerVideoSource ? (
                  <span
                    css={() => playTag(matches, index)}
                    onClick={() => handleClick(index.toString())}
                  >
                    <PlayButton
                      style={{
                        fontSize: "80px",
                      }}
                      sx={{ color: yellow[50] }}
                    ></PlayButton>
                  </span>
                ) : null)}
            </Box>
          ) : item.type === "hybrid" ? (
            <Box css={!matches && boxcontentHybrid}>
              {(item.media?.data?.attributes?.url ||
                item.media?.data?.attributes?.formats.small.url) && (
                <CardMedia
                  component="img"
                  style={{}}
                  css={() => media(matches)}
                  image={
                    process.env.REACT_APP_BASEURL +
                    (matches
                      ? item.media?.data?.attributes?.url
                      : item.media?.data?.attributes?.formats.small.url)
                  }
                ></CardMedia>
              )}
              <Box css={() => hybridImgText(matches)}>
                {item.features.map((ele, ind) => (
                  <Box
                    key={ind}
                    p={2}
                    pt={0}
                    pb={0}
                    style={
                      matches
                        ? ind === 0
                          ? { textAlign: "left" }
                          : {
                              textAlign: "left",
                              borderLeft: "2px solid white",
                            }
                        : ind === 0 || ind === 2
                        ? { textAlign: "left", marginBottom: "30px" }
                        : {
                            textAlign: "left",
                            borderLeft: "2px solid white",
                            paddingLeft: "40px",
                            marginBottom: "30px",
                          }
                    }
                  >
                    <Typography
                      p={1}
                      pt={0}
                      variant="body1"
                      css={fontFamilyWrapper}
                    >
                      {ele.heading}
                    </Typography>
                    <Typography
                      p={1}
                      style={{
                        fontSize: "40px",
                        fontFamily: "CorporateA-Regular",
                      }}
                      variant="h3"
                    >
                      {ele.description}
                    </Typography>
                    {ele?.buttonText && (
                      <a css={buttonText} href={ele?.buttonLink}>
                        {ele?.buttonText}
                      </a>
                    )}
                  </Box>
                ))}
              </Box>
              {matches && index === 0 && (
                <Fab
                  onClick={handleScroll}
                  style={{
                    bottom: "70px",
                    left: "48%",
                    background: "transparent",
                    boxShadow: "none",
                    zIndex: 1,
                  }}
                >
                  <KeyboardArrowDownIcon
                    style={{ fontSize: "40px" }}
                    sx={{ color: yellow[50] }}
                  ></KeyboardArrowDownIcon>
                </Fab>
              )}
            </Box>
          ) : (
            <Box></Box>
          )}
        </Grid>
      ))}
      {displayFlag && (
        <TableComponent
          tableData={tableData}
          characteristics={characteristics}
        />
      )}
      <Box sx={{ width: "100%", margin: "5%" }}>
        {accordionData.map((item, index) => (
          <Accordion key={index} disableGutters={true}>
            <AccordionSummary
              css={accordianSummaryStyle}
              expandIcon={<ExpandMoreIcon style={{ color: "white" }} />}
            >
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <div css={{ flex: "0.79" }}>{item?.attributes?.tabTitle}</div>
                <div style={{ marginRight: "10px" }}>
                  {item?.attributes?.buttonText}
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor: "#1f1c1c",
                color: "white",
                padding: 0,
              }}
            >
              {item?.attributes?.imageTextTile?.map((dataItem) =>
                renderCard(
                  dataItem?.image?.data?.attributes?.url,
                  dataItem?.image?.data?.attributes?.name,
                  dataItem?.title,
                  dataItem?.description,
                  matches ? "row" : "column",
                  dataItem?.isImageRequiredOnRight
                )
              )}
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
      {quickLinksData.length >= 0 && (
        <Grid item css={() => quickContainerCss(matches)} xs={12}>
          <QuickLinksComp quickLinksData={quickLinksData} />
        </Grid>
      )}
    </Grid>
  );
}
